import { Nullable } from "@/general/custom-types/CustomTypes";

export class AnomalyRemovalFormModel {
  sensors?: Nullable<number[]>;
  start?: Nullable<string>;
  end?: Nullable<string>;
  customer?: Nullable<number>;
  facilities?: Nullable<number[]>;
  referenceValue?: Nullable<number>;
  hour?: Nullable<boolean>;
  day?: Nullable<boolean>;
  month?: Nullable<boolean>;
  replacementValue?: Nullable<number>;
  replacing?: Nullable<boolean> = false;

  constructor(
    sensors?: Nullable<number[]>,
    start?: Nullable<string>,
    end?: Nullable<string>,
    customer?: Nullable<number>,
    facilities?: Nullable<number[]>,
    referenceValue?: Nullable<number>,
    hour?: Nullable<boolean>,
    day?: Nullable<boolean>,
    month?: Nullable<boolean>,
    replacementValue?: Nullable<number>,
    replacing?: Nullable<boolean>
  ) {
    this.sensors = sensors;
    this.start = start;
    this.end = end;
    this.customer = customer;
    this.facilities = facilities;
    this.referenceValue = referenceValue;
    this.hour = hour;
    this.day = day;
    this.month = month;
    this.replacementValue = replacementValue;
    this.replacing = replacing;
  }
}
